import { Trans } from "@lingui/react/macro"
import { Anchor, Button, Container } from "@mantine/core"
import { Link } from "@tanstack/react-router"

import type { IProps } from "./interfaces"

import classes from "./styles.module.css"

/**
 * Failed meeting. Same back-link and plain title as the other meeting pages,
 * then one card: what went wrong, and the few actions that still make sense.
 */
export const FailedMeetingView = ({
  title,
  dateLabel,
  reason,
  canRetry,
  canDelete,
  permanent,
  retrying,
  hasRecording,
  onRetry,
  onDelete,
  onPlay,
  audio,
}: IProps): React.JSX.Element => {
  return (
    <Container size="md" py="md" data-testid="failed-meeting">
      <Anchor component={Link} to="/" size="sm" className={classes.back}>
        &larr; <Trans>Meetings</Trans>
      </Anchor>
      <h1 className={classes.title}>{title}</h1>
      {dateLabel ? <p className={classes.date}>{dateLabel}</p> : null}
      <section className={`${classes.card} lex-surface-card`}>
        <h2 className={classes.heading}>
          <Trans>We couldn't finish this meeting</Trans>
        </h2>
        <p className={classes.reason}>{reason}</p>
        <div className={classes.actions}>
          {canRetry ? (
            <Button color="brand" onClick={onRetry} loading={retrying}>
              <Trans>Try again</Trans>
            </Button>
          ) : null}
          {canDelete ? (
            <Button variant="light" color="danger" onClick={onDelete}>
              {permanent ? <Trans>Delete permanently</Trans> : <Trans>Delete</Trans>}
            </Button>
          ) : null}
          {hasRecording ? (
            <Button variant="default" onClick={onPlay}>
              <Trans>Play the audio</Trans>
            </Button>
          ) : null}
        </div>
        {audio ? <div className={classes.audio}>{audio}</div> : null}
      </section>
    </Container>
  )
}
